import * as React from "react";

interface YouTubeProps {
    videoId: string;
}

export const YouTube: React.FC<YouTubeProps> = ({ videoId }) => {

    const source = `https://www.youtube.com/embed/${videoId}`;

    return <>
        <div className="container">
            <iframe width="560" height="315" src={source} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}>Video</iframe>;
        </div>
        <style jsx>
            {`
            .container {
                position: relative;
                overflow: hidden;
                width: 100%;
                padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
          }
            iframe{
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
            }
        `}
        </style>
    </>;
};
